import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Button from 'flarum/common/components/Button';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import app from 'flarum/forum/app';
import classList from 'flarum/common/utils/classList';
export default class BookmarkButton extends Component {
  constructor() {
    super(...arguments);
    /**
     * Guards against a second click while the first save is still in flight, which would
     * otherwise send a contradictory request.
     */
    _defineProperty(this, "saving", false);
  }
  view() {
    const _this$attrs = this.attrs,
      subject = _this$attrs.subject,
      labels = _this$attrs.labels,
      className = _this$attrs.className;
    const bookmarked = subject.bookmarked();
    return m(Button
    // Only the modifier is conditional. `Button` itself is left to the caller: core's
    // Button deliberately applies no class of its own, because a dropdown item must
    // *not* have it — adding it there stacks button padding on top of the menu item's
    // own and indents the row. Folding `Button` in here would also mean the class
    // appeared only once bookmarked, shifting the row on toggle.
    , {
      className: classList(className, {
        'Button--bookmarked': bookmarked
      }),
      icon: m(Icon, {
        name: bookmarked ? 'fas fa-bookmark' : 'far fa-bookmark',
        className: "Button-icon",
        noStyleOverride: true
      }),
      loading: this.saving,
      onclick: () => this.toggle()
    }, app.translator.trans("fof-bookmarks.forum.".concat(labels, ".").concat(bookmarked ? 'remove' : 'add')));
  }
  toggle() {
    if (this.saving) return;
    const _this$attrs2 = this.attrs,
      subject = _this$attrs2.subject,
      alert = _this$attrs2.alert;

    // Read before saving: the attribute is what we are about to invert.
    const wasBookmarked = subject.bookmarked();
    this.saving = true;
    subject.save({
      bookmarked: !wasBookmarked
    }).then(() => {
      if (alert) this.showAlert(!wasBookmarked);
    }).catch(() => {
      // Flarum's default error handler has already told the user. Nothing to add.
    }).then(() => {
      this.saving = false;
      m.redraw();
    });
  }
  showAlert(bookmarked) {
    const message = app.translator.trans("fof-bookmarks.forum.alert.".concat(bookmarked ? 'added' : 'removed'));

    // Offering a link to the bookmarks page is pointless when already looking at it.
    if (app.current.get('routeName') === 'fof-bookmarks') {
      app.alerts.show({
        type: 'success'
      }, message);
      return;
    }
    const alert = app.alerts.show({
      type: 'success',
      controls: [m(Button, {
        className: "Button Button--link",
        onclick: () => {
          m.route.set(app.route('fof-bookmarks'));
          // Dismissing on navigation stops the alert outliving the page it refers to.
          app.alerts.dismiss(alert);
        }
      }, app.translator.trans('fof-bookmarks.forum.alert.show_bookmarks'))]
    }, message);
  }
}
flarum.reg.add('fof-bookmarks', 'forum/components/BookmarkButton', BookmarkButton);